import { createFileRoute } from '@tanstack/react-router'

import LoggerStatus from 'pages/LoggerStatus'

export const Route = createFileRoute('/_auth/_global/loggers/status')({
  component: LoggerStatus,
})
